import { Line } from 'react-chartjs-2';
import { ReactComponent as InsightsIcon } from '../../../../../../../assets/vectors/insights.svg';
import { DashboardWidgetProps } from './DashboardDIRWidget.types';

export default ({
  title,
  subtitle,
  currentStat,
  stats,
  progression = 0,
  isSecondary,
}: DashboardWidgetProps) => {
  return (
    <div className={`dashboard__widget ${isSecondary ? 'dashboard__widget--secondary' : ''}`}>
      <div className="dashboard__widget-row">
        <div className="flex-row">
          <div className="dashboard__widget-icon">
            <InsightsIcon />
          </div>
          <div className="flex-column">
            <label className="dashboard__widget-title">{title}</label>
            <span className="dashboard__widget-subtitle">{subtitle}</span>
          </div>
        </div>
      </div>
      <div className="dashboard__widget-main">
        <div className="flex-row align-center">
          <span className="dashboard__widget-main-value">{currentStat}</span>
          {progression ? (
            <span
              className={`dashboard__widget-main-percentage${
                progression < 0 ? ' dashboard__widget-main-percentage--negative' : ''
              }`}>
              {parseInt(progression.toFixed(0))}%
            </span>
          ) : null}
        </div>
        <div className="dashboard__widget-main-chart">
          <Line
            datasetIdKey="id"
            width={80}
            height={40}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
              elements: {
                line: {
                  borderColor: isSecondary ? '#206C87' : '#DE5835',
                },
              },
              scales: {
                x: {
                  display: false,
                  grid: {
                    display: false,
                  },
                },
                y: {
                  display: false,
                  grid: {
                    display: false,
                  },
                },
              },
            }}
            data={{
              labels: stats?.map(() => ''),
              datasets: [
                {
                  label: '',
                  data: stats,
                  borderWidth: 1,
                  pointRadius: 2,
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  );
};
